import { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from "react-select";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { formatDate, formatDateTime, SubmitButton } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData } from "../../Constants/constants";
import * as XLSX from 'xlsx'

class PolicyReport extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      company_location_shift_id: 0,
      leave_type_ids: "",
      effective_date: null,
      location_shift_id: "",
      grade_id: "",
      designation_id: "",
      location_id: "",
      department_id: "",
      category_id: "",
      state_id:"",
      employee_type_id:"",
      policy_published_list:"All",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      assignLeaveModal: false,
      Shift_rows: [],
      capturemode_options: '',
      location_options: [],
      department_options: [],
      designation_options: [],
      grade_options: [],
      state_options: [],
      category_options: [],
      type_options: [],
      location_row: [],
      company_location_shift_row: [],
      days_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      loadingFilter: false,
      loadingSearch: false,
      decodedData: [],
      assigned_policy_status: 'All',
      company_policy_id: 0,
    };
  }
  componentDidMount() {
    // console.log("current date and time ==========>>>>>>>>>",currentDateAndTime());
    this.setState({ loadingList: true }, (prevState) => {
    this.GetList();
    this.GetPolicyList();
    this.GetShiftList();
    this.getAllEmployeesOptionList();
    this.GetEmploymentMasterList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state.assigned_leave_status",this.state.assigned_leave_status);
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context; 
    const headers = apiHeaderJSON;
    
    // Axios GET request
    axios
      .get(`${apiURL}Employees/GetPublishedPolicyReport`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          grade_id: this.state.grade_id || null,
          designation_id: this.state.designation_id || null,
          location_id: this.state.location_id || null,
          department_id: this.state.department_id || null,
          category_id: this.state.category_id || null,
          assigned_policy_status: this.state.assigned_policy_status==="All" ? null : this.state.assigned_policy_status,
          company_policy_id: this.state.company_policy_id || null,

        },
        headers,
      })
      .then((response) => {
        // Check if the API call was successful
        if (response.data.success === true) {
          const data = response.data;
          console.log("GetPublishedPolicyReport data",data);
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
          });
        }
        this.setState({
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
      })
      .catch((error) => {
        // Handle API errors
        console.error("Error fetching data:", error);
        this.setState({
          loadingList: false,
          loadingSearch: false,
          loadingFilter: false,
        });
      });
  };



    GetPolicyList = () => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      axios
        .get(`${apiURL}Masters/GetPolicyList`, {
          params: { limit: 999, page: 1, keyword: ""},
          headers,
        })
        .then((response) => {
          var data = response.data;
          if (response.data.success === true) {
            const temp= data.data?.map((val)=>{
              return {value:val?.company_policy_id, label: val?.company_policy_title}
            })
            this.setState({
              policy_rows: temp,

            });
          } else {
            this.setState({ loadingList: false });
          }
        });
    };

  getAllEmployeesOptionList = (e) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    try {
      axios
        .get(`${apiURL}Masters/GetCompanyEmployeesList`, { params: { keyword: '' }, headers })
        .then((response) => {
          if (response.data.success === true) {
            this.setState({ allEmpOptions: response.data.data });
            // console.log("GetCompanyEmployeesList =>",response.data.data);
          } else {
            this.setState({allEmpOptions:[]});
          }
        })
    } catch (error) {
      console.error("error", error)
    }
}

  
  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
      employee_ids: this.state.selectedRows,
      policy_published_list: this.state.policy_published_list,
      want_to_notify: this.state.want_to_notify || "0",
      other_employee_ids: this.state.other_employee_ids,
      date: currentDateAndTime(),
    };
    // console.log("form data ====>>>", formData);
    axios
      .post(`${apiURL}Employees/AssignPoilcy`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          this.setState(
            {
              loadingList: true,
              selectedRows: [],
              policyPublishModal:false,
              policy_id: "",
              postLoading:false,
            },
            (prevState) => {
              this.GetList();
            //   this.GetLocationList();
            //   this.GetDepartmentMasters();
              this.GetShiftList();
              this.GetEmploymentMasterList();
            }
          );
        } else {
          this.setState({ loadingList: true, postLoading:false });
        }
        Swal.fire({
        title: `<strong>${
            response.data.success === true ? "Success" : "Failed"
        }</strong>`,
        text: response.data.message,
        icon: response.data.success === true ? "success" : "error",
        showConfirmButton: true,
        allowOutsideClick: false,
        });
      })
      .catch((error)=>{
        this.setState({ loadingList: true, postLoading:false });
        Swal.fire({
            title: `<strong>Failed}</strong>`,
            text: "Opps...! Something went wrong.",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
        });
      });
  };

  handleInputSearch = (e) => {
      this.GetList();
  };
  handleClearAll = () => {
    this.setState(
      {
        grade_id: "",
        designation_id: "",
        location_id: "",
        department_id: "",
        category_id: "",
        location_shift_id: "",
        policy_published_list: "All",
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        assigned_policy_status:"All",
        company_policy_id: 0,
      },
      () => {
        this.GetList();
      }
    );
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },
    () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };

  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };

  handleMultiSelect = (fieldName, selectedOptions) => {
    if (selectedOptions.some(option => option.value === "All")) {
        // Get all options except "All"
        const ids = this.state.DataCaptures
            ? this.state.DataCaptures
                  .filter(option => option.value !== "All")
                  .map(option => option.value)
            : [];
        // console.log(ids.join(','));
        this.setState({ [fieldName]: ids.join(',') });
    } else {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ [fieldName]: ids.join(',')});
    }
};


  handleCheckboxChange = (row) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(row?.employee_id)) {
        selectedRows.splice(selectedRows.indexOf(row?.employee_id), 1);
      } else {
        selectedRows.push(row?.employee_id);
      }

      return { selectedRows };
    },()=>{
        if(this.state.selectedRows.length===1){
            this.setState({ policy_published_list: row?.assigned_policies})
        }
        else{
            this.state.policy_published_list &&  this.setState({ policy_published_list: ""})
        }
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows =
        prevState.selectedRows.length === prevState.rows.length
          ? []
          : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      this.setState({
        selectedRows: this.state.rows.map((row) => row.employee_id),
      });
    } else if (action === "deselect-all") {
      this.setState({ selectedRows: [] });
    }
  };

  GetViewList = (row) => {
    this.setState({
      policy_published_list: row?.assigned_policies,
      policyPublishView: row,
    })
  };
  GetLogList = (row) => {
    
  };
  GetShiftList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetShiftList `, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Shift_rows: data.data.map((row) => ({
              value: row.company_location_shift_id,
              label: row.company_location_shift_name,
            })),
          }));
        }
      });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.department;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          department_options: data.map((row) => ({
            value: row.department_id,
            label: row.department_title,
          })),
        }));
      }
    });
  };
  GetPolicy = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Attendance/GetAssignedCaptureMode`, 
        { params: { 
            limit: 999, 
            page: 1 
        }, headers })
    .then((response) => {
      const data = response.data.data;
      if (response.data.success === true) {
        // console.log("GetAssignedCaptureMode===>",data);
        const temp = data.map((row) => ({
            value: row.policy_id,
            label: row.policy_published_list_name,
          }));
        temp.unshift({value:'All', label:"All"});
        // console.log("temp",temp);
        this.setState((prevState) => ({
          capturemode_options: temp,
        }));
      }
    });
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            location_options: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetEmploymentMasterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
      .then((response) => {
        let data = response.data;
        if (response.data.success === true) {
            data= data?.data;
          this.setState((prevState) => ({
            location_options: data.location_list.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
            department_options: data?.department_list.map((row) => ({
                value: row.department_id,
                label: row.department_title,
              })),
            designation_options: data?.designation_list.map((row) => ({
                value: row.designation_id,
                label: row.designation_title,
              })),
            grade_options: data?.grade_list.map((row) => ({
                value: row.grade_id,
                label: row.grade_title,
              })),
            state_options: data?.state_list.map((row) => ({
                value: row.state_id,
                label: row.state_title,
              })),
            category_options: data?.category_list.map((row) => ({
                value: row.company_employee_category_id,
                label: row.company_employee_category,
              })),
            type_options: data?.type_list.map((row) => ({
                value: row.company_employee_type_id,
                label: row.company_employee_type,
              })),
          }));  
        }
      });
  };

  handleExcelDownload = () => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
  
      Swal.fire({
        title: 'Please wait...',
        html: 'Your file is being prepared for download.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
  
      axios
        .get(`${apiURL}Employees/GetPublishedPolicyReport`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          grade_id: this.state.grade_id || null,
          designation_id: this.state.designation_id || null,
          location_id: this.state.location_id || null,
          department_id: this.state.department_id || null,
          category_id: this.state.category_id || null,
          assigned_policy_status: this.state.assigned_policy_status==="All" ? null : this.state.assigned_policy_status,
          company_policy_id: this.state.company_policy_id || null,
        },
          headers,
        }).then((response) => {
          if (response.data.success === true) {
            const rows = response.data.data;
  
            const data = rows.map(row => ({
                'Published Date': row?.policy_assign_date ? formatDate(row?.policy_assign_date) : '--',
                'Employee Code': row.employee_code || '--',
                'Employee Name': row.employee_name || '--',
                'Policy': row.company_policy_title || '--',
                'Designation': row.designation_title || '--',
                'Department': row.department_title || '--',
                'Location': row.location_title || '--',
                'Status': row.PolicyStatus || '--',
                'Reviewed Date': row?.reviewed_date ? formatDateTime(row?.reviewed_date) : '--',
                'Remark': row.company_policy_remarks || '--',
            }));
  
            const columns = [
                { header: 'Published Date', key: 'Published Date', width: 20 },
                { header: 'Employee Code', key: 'Employee Code', width: 20 },
                { header: 'Employee Name', key: 'Employee Name', width: 20 },
                { header: 'Policy', key: 'Policy', width: 20 },
                { header: 'Designation', key: 'Designation', width: 20 },
                { header: 'Department', key: 'Department', width: 20 },
                { header: 'Location', key: 'Location', width: 20 },
                { header: 'Status', key: 'Status', width: 20 },
                { header: 'Reviewed Date', key: 'Reviewed Date', width: 20 },
                { header: 'Remark', key: 'Remark', width: 20 },
            ];
            
  
            const wb = XLSX.utils.book_new();
  
            const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
  
            ws['!cols'] = columns.map(column => ({ wch: column.width }));
  
            XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });
  
            columns.forEach((column, index) => {
              ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
            });
  
            XLSX.utils.book_append_sheet(wb, ws, 'Policy Report');
  
            // XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${Date()}).xlsx`);
            
            XLSX.writeFile(wb, `Policy Report ${formatDate(currentDateAndTime())}.xlsx`);
  
            Swal.close();
  
            Swal.fire({
              title: '<strong>Success</strong>',
              html: 'Your file has been downloaded successfully.',
              icon: 'success',
              showConfirmButton:true,
              allowOutsideClick: false,
            });
          } else {
            Swal.close();
            Swal.fire({
              title: '<strong>Error</strong>',
              html: response.data.message,
              icon: 'error',
              showConfirmButton:true,
              allowOutsideClick: false,
            });
          }
          this.setState({loadingFilter: false});
        })
        .catch((error) => {
            this.setState({loadingFilter: false});
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error',
                showConfirmButton:true,
                allowOutsideClick: false,
            });
        });
    }

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetShiftList();
        this.GetLocationList();
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };


  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, ];
    const assignedStatusOptions=[
        {value:"All", label:"All"},
        {value:"1", label:"Reviewed"},
        {value:"0", label:"Published"},
        
    ];

    return (
      
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Policy Report`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                        <div className="col-md-3">
                            <label htmlFor="keyword">Employee Name/Code</label>
                            <div className="input-group">
                            <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} 
                            aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Here..."/>
                            <button className="btn btn-success" disabled={this.state.loadingSearch}
                                onClick={() => {
                                if ( this.state.keyword && !this.state.loadingSearch ) {
                                    this.handleInputSearch();
                                }}} 
                                type="button" id="button-addon2">
                                {this.state.loadingSearch ? (
                                    <span class="spinner-border flex-shrink-0" role="status"
                                    style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                    ) : (
                                    <i className="ri-search-line"></i>
                                )}
                            </button>
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                <div><label>Grade</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange("grade_id", selectedOption) }
                                placeholder={`Select Grade`} options={this.state.grade_options}
                                value={ this.state.grade_id ? this.state.grade_options.find( (option) => option.value === this.state.grade_id ) : null }
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                                <div><label>Designation</label></div>
                                <Select  onChange={(selectedOption) => this.handleSelectChange("designation_id",  selectedOption) }
                                placeholder={`Select Designation`} options={this.state.designation_options}
                                value={ this.state.designation_id ? this.state.designation_options.find( (option) => option.value === this.state.designation_id ) : null }
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                <div><label>Location</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange("location_id", selectedOption) }
                                placeholder={`Select Location`} options={this.state.location_options}
                                value={ this.state.location_id ? this.state.location_options.find( (option) =>  option.value === this.state.location_id ) : null }
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                                <div><label>Department</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange("department_id", selectedOption) }
                                placeholder={`Select Department`} options={this.state.department_options}
                                value={  this.state.department_id ? this.state.department_options.find( (option) => option.value === this.state.department_id ) : null }
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 6, width: "90%" }}className=" position-absolute">
                                <div><label>Category</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange("category_id", selectedOption) }
                                placeholder={`Select Category`} options={this.state.category_options}
                                value={ this.state.department_id ? this.state.category_options.find((option) => option.value === this.state.category_id) : null }
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                                <div><label>Policy Status</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange("assigned_policy_status", selectedOption) }
                                placeholder={`All`} options={assignedStatusOptions}
                                value={ this.state.assigned_policy_status ? assignedStatusOptions.find( (option) => option.value === this.state.assigned_policy_status ) : null}
                                />
                            </div>
                        </div>
                        <div className="mb-4rem col-md-3 position-relative">
                            <div style={{ zIndex: 4, width: "90%" }}className=" position-absolute">
                                <div><label>Policy</label></div>
                                <Select onChange={(selectedOption) => this.handleSelectChange( "company_policy_id", selectedOption) }
                                placeholder={`All`} options={this.state.policy_rows}
                                value={ this.state.company_policy_id ? this.state.policy_rows.find( (option) => option.value === this.state.company_policy_id ) : null }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <div><label>Apply Filter</label></div>
                                    <SubmitButton otherClasses='w-100' onClick={()=>{ if(!this.state.loadingFilter){ this.setState({loadingFilter: "1"}, () => { this.handleInputSearch()}) } }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_policy_status || this.state.assigned_policy_status==="All") && (!this.state.company_policy_id || this.state.company_policy_id==="All")}
                                    loading={this.state.loadingFilter==="1"}
                                    loadingMessage='loading' buttonName={"Filter"} icon={'ri-filter-3-fill'} 
                                    type='info' iconSide='left' />
                                </div>
                                <div className="col-md-6 col-6">
                                    <div>
                                        <label>Clear Filter</label>
                                    </div>
                                    <SubmitButton otherClasses='w-100' onClick={()=>{ if(!this.state.loadingFilter){ this.setState({loadingFilter: "2"}, () => { this.handleClearAll()}) } }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_policy_status || this.state.assigned_policy_status==="All") && (!this.state.company_policy_id || this.state.company_policy_id==="All")}
                                    loading={this.state.loadingFilter==="2"}
                                    loadingMessage='loading' buttonName={"Clear"} icon={'ri-database-2-line'} 
                                    type='secondary' iconSide='left' />
                                </div>
                            </div>
                        </div>
                            <div className="col-md-6 col-6">
                                <div>
                                    <label>Excel Export</label>
                                </div>
                                <SubmitButton otherClasses='noWrap' onClick={()=>{ if(!this.state.loadingFilter){ this.setState({loadingFilter: "3"}, () => { this.handleExcelDownload()}) } }}
                                disabled={this.state.rows.length === 0} loading={this.state.loadingFilter==="3"} loadingMessage='loading' 
                                buttonName={"Excel Export"} icon={'ri-file-excel-2-line'} 
                                type='success' iconSide='left' />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div>
                            <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                                <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative"
                                    style={{ minWidth: '100%' }}>
                                <thead  className="bg-primary text-light bg-gradient  sticky-top z-1">
                                    <tr>
                                    {/* {this.state.rows.length>0 && this.state.decodedData?.includes(3) && (
                                    <th>
                                        <div className="d-flex gap-1 align-items-center justify-content-center">
                                            <input type="checkbox" className="form-check-input cursorPointer" 
                                            checked={this.state.selectedRows.length === this.state.rows.length && this.state.rows.length>0}
                                            onChange={this.handleSelectAll}
                                            />
                                            Select{" "}
                                            {this.state.selectedRows?.length > 0 && ( <span className="text-white">({this.state.selectedRows?.length})
                                            </span>
                                            )}
                                        </div>
                                    </th>)} */}
                                    <th className=" text-center noWrap">Published Date</th>
                                    <th>Employee Code</th>
                                    <th>Employee Name</th>
                                    <th>Policy</th>
                                    {/* <th>Work Email</th> */}
                                    <th className=" text-center">Status</th>
                                    <th className=" text-center noWrap">Reviewed Date</th>
                                    <th>Remark</th>
                                    {/* <th className=" text-center">Action</th> */}
                                    </tr>
                                </thead>
                                {this.state.rows.length === 0 ? (
                                    <tbody>
                                    <tr>
                                        <td colSpan={11}>
                                        <NoRecords />
                                        </td>
                                    </tr>
                                    </tbody>
                                ) : (
                                    <tbody>
                                    {this.state.rows.map((row) => {
                                        return (
                                        <tr key={row.employee_policy_review_id}>
                                            {/* { this.state.decodedData?.includes(3) && (
                                            <td>
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <input type="checkbox" className="form-check-input" checked={this.state.selectedRows.includes( row.employee_id )}
                                                    onChange={() => this.handleCheckboxChange( row ) }
                                                    />
                                                </div>
                                            </td>)} */}
                                            <td className=" text-center">{row.policy_assign_date? formatDate(row?.policy_assign_date) : "--"}</td>
                                            <td>{row.employee_code || '--'}</td>
                                            <td>{row.employee_name || '--'}</td>
                                            <td>{row.company_policy_title || '--'}</td>
                                            {/* <td>{row.employee_email_address}</td> */}
                                            <td>
                                            <div style={{ fontSize: "0.65rem" }} className={` bg-${row?.PolicyStatusClasses} fw-semibold px-1 text-center py-1 text-white rounded-4`}>
                                                {row.PolicyStatus || '--' }
                                            </div>
                                            </td>
                                            <td className=" text-center">{row.reviewed_date? formatDateTime(row?.reviewed_date) : "--"}</td>
                                            <td className={`${row?.company_policy_remarks?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row.company_policy_remarks || '--'}</td>
                                            {/* <td className=" text-center">
                                                <div className="d-flex justify-content-around gap-2">
                                                { this.state.decodedData?.includes(1) && (
                                                    <IconButton 
                                                    disabled={!row.assigned_policy_names || row.assigned_policy_names?.length===0}
                                                    loading={this.state.loadingList }
                                                    onClick={() => { this.GetViewList(row);}} 
                                                    type='primary' icon='ri-file-info-line' tooltipName={row.assigned_policy_names && row.assigned_policy_names?.length>0 ?'View':""} tooltipPosition='bottom' />
                                                    )}
                                                </div>
                                            </td> */}
                                        </tr>
                                        );
                                    })}
                                    </tbody>
                                )}
                                </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center flex-wrap bg-light w-100 py-2 px-2">
                                <button disabled={ this.state.prev === false && this.state.loadingList === false}
                                className={`btn btn-warning btn-label waves-effect waves-light`} type="button"
                                onClick={() => this.handlePrev()}>
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                    Previous
                                </button>
                                <div className="col-md-4" style={{ display: "flex", alignItems: "center", }}>
                                    {<small> 
                                        Total Records: {this.state.total_records} | 
                                        Total Pages: {this.state.total_pages} | 
                                        Current Page: {this.state.page}
                                    </small>}
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                        {Array.from(
                                        { length: this.state.total_pages },
                                        (_, i) => (
                                            <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                Page {i + 1}
                                            </option>)
                                        )}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                        <option value={this.state.total_records}>
                                            All
                                        </option>
                                        {limitOptions.map((option) => ( <option key={option} value={option}> Limit {option} </option> ))}
                                    </select>
                                </div>
                                <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                type="button" onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}>
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    );
  }
}
export default withRouter(PolicyReport);
